import { createClient } from '@supabase/supabase-js';

export const supabase = createClient(
  'https://msnuqdqndtrjkorvlelr.supabase.co',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1zbnVxZHFuZHRyamtvcnZsZWxyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODI0OTY5MTcsImV4cCI6MjA5ODA3MjkxN30.wB_9VtJVasWH_jDAqE7Hw4gV4sol1meqU9ypm0zRAtU'
);
